import React, { useCallback } from 'react'
import cn from 'classnames'
import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TrackingContainer } from '@mc/visibility'
import { PricingText } from 'components/PricingText'
import { trackDecreaseStandardPriceEV } from 'experiments/prcng-861_v1_decrease_standard_price'
import classes from './IncludedBanner.module.scss'

export const IncludedBanner = () => {
  const { t } = useTranslation('@mc/next')

  /**
   * Tracking for price change experiments.
   * Eg. tracking experiment view
   */
  const onPriceVisible = useCallback(() => {
    trackDecreaseStandardPriceEV()
  }, [])

  return (
    <div className='d-flex justify-content-center'>
      <div
        className={cn(
          classes.container,
          'd-flex justify-content-center align-items-center mc-bg-light mc-theme-light mc-py-3 mc-px-4 mc-corners--sm',
        )}
      >
        <span className={classes.logo}>
          <Icon
            className='mc-icon--5'
            kind='logo'
            srText={t('sessions.includedBanner.logoAlt')}
          />
        </span>
        <div className='mc-pl-4 mc-body mc-opacity--muted mc-text-x-small mc-text--left'>
          <TrackingContainer onFirstVisible={onPriceVisible}>
            <PricingText />
          </TrackingContainer>
        </div>
      </div>
    </div>
  )
}
